import { useEffect } from 'react';

export const EndUserLicenseAgreement = () => {
  return (
    <div className="policy-container" style={{ backgroundColor: 'white', height: '100vh', width: '100%' }}>
      <iframe
        src="https://app.termly.io/policy-viewer/policy.html?policyUUID=1254fe0d-76f3-427b-bddb-4c1dcf280f93"
        title="End User License Agreement"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
      />
    </div>
  );
};
